// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content050_wrapper__tY5qn","title":"Content050_title__lvfHh"};